import './_popup.scss';
import anime from 'animejs';
import initMobileAerialMapPopup from './aerial-map-popup';
import initMobileInteractiveMapPopup from './interactive-map-popup';
import { config, debounce, getScrollbarWidth, responsive } from '../../../utilities';

$(() => {
    const popupSel = '.popup';
    const $popup = $(popupSel);
    const $header = $('#header');
    if (!$popup.length && !$header.length) {
        return;
    }
    let h = window.innerHeight;

    function setPopupViewportHeight($target) {
        // 100vh not working well on mobile
        // https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser
        h = window.innerHeight;
        $target.css('height', `${h}px`);
    }

    function addScrollbarPaddingsToBody() {
        const scrollbarW = getScrollbarWidth();
        $('body').css('padding-right', `${scrollbarW}px`);
        $header.css('padding-right', `${scrollbarW}px`);
    }

    function removeBodyClasses(remove, callback = null) {
        if (remove && remove.length) {
            const regex = new RegExp(`(^|\\s)\\S+-${remove}`, 'g');
            $('body').removeClass((_, className) => (className.match(regex) || []).join(' '));
        } else {
            return;
        }
        $('body').css('padding-right', '0px');
        $header.css('padding-right', '0px');
        if (callback) callback();
    }

    function initPrimaryPopup() {
        const maxPrimaryHeight = 900;
        let isNonFixedOpen = false;
        let isNonFixedOpenComplete = false;
        const popupPrimarySel = '#popup-primary';
        const $popupPrimary = $(popupPrimarySel);
        if (!$popupPrimary.length) return;

        const headWrapperSel = '.popup--primary__container';
        // init anime
        const openPopupAnime = anime.timeline({
            duration: config.animateTime.standard,
            ...config.animeConfig,
        });
        const closePopupAnime = anime.timeline({
            duration: config.animateTime.standard,
            ...config.animeConfig,
        });
        // Configs
        let mt = `-${$popupPrimary.outerHeight()}px`;
        let t = 0;
        let headerH = 0;
        let popupH = 0;

        // Header enters into popup
        function scroll() {
            const gap = $(window).scrollTop() + headerH + popupH - t;
            if (gap >= 0 && isNonFixedOpen) {
                $('body').addClass('show-header-popup-close');
                $header.addClass('show-motif');
            } else {
                $('body').removeClass('show-header-popup-close');
                $header.removeClass('show-motif');
            }
        }

        function initPrimaryPopupHeader() {
            t = $popupPrimary.offset().top;
            headerH = $header.outerHeight();
            if (isNonFixedOpenComplete) {
                popupH = 0;
            } else {
                popupH = $popupPrimary.outerHeight();
            }
            window.removeEventListener('scroll', scroll);
            scroll();
            window.addEventListener('scroll', scroll);
        }

        // update anime properties and height
        window.addEventListener(
            'resize',
            debounce(() => {
                setPopupViewportHeight($popupPrimary);
                mt = `-${Math.min($popupPrimary.outerHeight(), maxPrimaryHeight)}px`;
                if (isNonFixedOpen) {
                    $popupPrimary.css('margin-top', mt);
                    initPrimaryPopupHeader();
                }
            }, 300)
        );

        const closeFunc = () => {
            closePopupAnime.play();
            isNonFixedOpen = false;
            $('body').removeClass('show-header-popup-close');
            window.removeEventListener('scroll', scroll);
        };

        // click event for close button
        $('#popup-primary .popup__close, #header .popup__close').on('click', () => {
            // close popup
            closeFunc();
        });

        // fixed anime
        const initFixedAnime = () => {
            $popupPrimary.css('margin-top', 0);
            openPopupAnime.remove(popupPrimarySel);
            closePopupAnime.remove(popupPrimarySel);
            openPopupAnime.remove(headWrapperSel);
            closePopupAnime.remove(headWrapperSel);
            // closing animation for popup and popup container, play simultaneously
            closePopupAnime.add(
                {
                    targets: popupPrimarySel,
                    top: [0, '100%'],
                    begin: () => {
                        $('body').addClass('close-primary-fixed-popup');
                    },
                    complete: () => {
                        $popupPrimary.hide();
                        $('body').removeClass('open-primary-fixed-popup');
                        $('body').removeClass('close-primary-fixed-popup');
                        removeBodyClasses('primary-popup');
                        $('body').removeClass('open-primary-main-popup');
                        $header.removeClass('show-motif');
                    },
                },
                0
            );
            closePopupAnime.add(
                {
                    targets: headWrapperSel,
                    translateY: [0, '-100%'],
                    opacity: [1, 0],
                },
                0
            );
            // opening animation for menu and menu container, play simultaneously
            openPopupAnime.add(
                {
                    targets: popupPrimarySel,
                    top: ['100%', 0],
                    begin: () => {
                        $popupPrimary.show();
                        $('body').addClass('show-header-popup-close');
                        $('body').addClass('open-primary-fixed-popup');
                    },
                },
                0
            );
            openPopupAnime.add(
                {
                    targets: headWrapperSel,
                    translateY: ['-100%', 0],
                },
                0
            );
        };

        // non-fixed anime
        const initNonFixedAnime = () => {
            $popupPrimary.css('top', 0);
            openPopupAnime.remove(popupPrimarySel);
            closePopupAnime.remove(popupPrimarySel);
            openPopupAnime.remove(headWrapperSel);
            closePopupAnime.remove(headWrapperSel);
            // closing animation for popup and popup container, play simultaneously
            closePopupAnime.add(
                {
                    targets: popupPrimarySel,
                    marginTop: [mt, 0],
                    complete: () => {
                        $popupPrimary.hide();
                        removeBodyClasses('primary-popup');
                        $('body').removeClass('open-primary-main-popup');
                        $header.removeClass('show-motif');
                    },
                },
                0
            );
            closePopupAnime.add(
                {
                    targets: headWrapperSel,
                    translateY: [0, '-100%'],
                    opacity: [1, 0],
                },
                0
            );
            // opening animation for menu and menu container, play simultaneously
            openPopupAnime.add(
                {
                    targets: popupPrimarySel,
                    marginTop: [0, mt],
                    begin: () => {
                        $popupPrimary.show();
                        isNonFixedOpenComplete = false;
                        initPrimaryPopupHeader();
                    },
                    complete: () => {
                        isNonFixedOpenComplete = true;
                    },
                },
                0
            );
            openPopupAnime.add(
                {
                    targets: headWrapperSel,
                    translateY: ['-100%', 0],
                },
                0
            );
        };

        // listen on toggling popup events
        $('body').on('click', '[data-toggle="primary-popup"][data-class]', (event) => {
            const $trigger = $(event.currentTarget);
            const $target = $(
                $trigger.data('target') ? $trigger.data('target') : $trigger.attr('href')
            );
            const newClass = $trigger.data('class');
            const closePopup = $trigger.data('close-popup');
            let isFixed = $trigger.data('popup-type') === 'fixed';
            if ($('body').hasClass('open-menu')) {
                isFixed = true;
            }

            if (closePopup) {
                removeBodyClasses(closePopup);
            }

            if ($target.length) {
                event.preventDefault();
                if ($('body').attr('class').includes(newClass)) {
                    // close popup when clicking itself
                    closeFunc();
                } else {
                    // open popup
                    // close other popups and open itself
                    removeBodyClasses('primary-popup');
                    if (!$('body').hasClass('open-primary-main-popup')) {
                        $('body').addClass('open-primary-main-popup');
                        if (isFixed) {
                            $popupPrimary.addClass('fixed-popup');
                            initFixedAnime();
                            openPopupAnime.play();
                        } else {
                            $popupPrimary.removeClass('fixed-popup');
                            initNonFixedAnime();
                            isNonFixedOpen = true;
                            openPopupAnime.play();
                        }
                    }
                    $target.toggleClass(newClass);
                }
            }
        });
    }

    function initSecondaryPopup() {
        const $secondaryPopup = $('#popup-secondary');
        if (!$secondaryPopup.length) {
            return;
        }

        const $closeBtn = $secondaryPopup.find('.popup__close');
        let timeOut;
        function closePopup() {
            removeBodyClasses('secondary-popup');
            window.clearTimeout(timeOut);
            timeOut = window.setTimeout(() => {
                $secondaryPopup.find('.popup__content').html('');
            }, config.animateTime.standard);
        }
        $closeBtn.on('click', closePopup);
        setPopupViewportHeight($secondaryPopup);
        window.addEventListener(
            'resize',
            debounce(() => {
                setPopupViewportHeight($secondaryPopup);
                responsive.breakAt({
                    callback: () => $closeBtn.trigger('click'),
                    from: 'md',
                });
            }, 300)
        );

        $('body').on('click', '[data-toggle="popup-secondary"][data-class]', (event) => {
            const $trigger = $(event.currentTarget);
            const $target = $(
                $trigger.data('target') ? $trigger.data('target') : $trigger.attr('href')
            );
            const newClass = $trigger.data('class');
            const copyContentSel = $trigger.data('popup-content');
            const popupType = $trigger.data('type');
            const copyContent = $(copyContentSel).html();

            if ($target.length) {
                event.preventDefault();
                if ($('body').attr('class').includes(newClass)) {
                    removeBodyClasses('secondary-popup');
                } else {
                    removeBodyClasses('secondary-popup');
                    addScrollbarPaddingsToBody();
                    setPopupViewportHeight($secondaryPopup);
                    $('body').addClass('open-secondary-popup');
                    $target.toggleClass(newClass);
                    $secondaryPopup.find('.popup__content').html(copyContent);
                }
            }

            if (popupType === 'aerial-map') {
                initMobileAerialMapPopup();
            }
            if (popupType === 'imap') {
                initMobileInteractiveMapPopup();
            }
        });
    }

    initPrimaryPopup();
    initSecondaryPopup();
});
